import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { ScgpUserQuery } from "@saleor/graphql";
import { UserDetailMode } from "@saleor/userManagement/constants";
import React from "react";
import { useIntl } from "react-intl";

import UISwitch from "../UISwitch";
import useStyles from "./styles";

interface FormSwitchActiveProps {
  formik?: any;
  user?: ScgpUserQuery;
  mode?: UserDetailMode;
}

const FormSwitchActive: React.FC<FormSwitchActiveProps> = ({
  formik,
  mode,
  user
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      {mode !== UserDetailMode.CREATE && (
        <Grid item md={6} className={classes.flex}>
          <MyTypography variant={"body3"}>
            {intl.formatMessage({ defaultMessage: "สถานะ: " })}
          </MyTypography>
          {mode === UserDetailMode.VIEW && (
            <MyTypography
              variant={"subtitle3"}
              className={user?.scgpUser?.isActive ? classes.info : null}
              style={{ marginLeft: "0.5rem" }}
            >
              {user?.scgpUser?.isActive ? "Active" : "Inactive"}
            </MyTypography>
          )}
          {mode === UserDetailMode.EDIT && (
            <div style={{ marginLeft: "2rem" }}>
              <UISwitch
                onChange={formik.handleChange}
                label="Active"
                name="isActive"
                id="isActive"
                defaultChecked={user?.scgpUser?.isActive}
              />
            </div>
          )}
        </Grid>
      )}
    </>
  );
};

export default FormSwitchActive;
